import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Container,
  makeStyles,
  TableBody,
  TableHead,
  TablePagination,
  Grid,
} from "@material-ui/core";
import { doctorServices, userServices } from "../services";
import { AuthContext } from "../context";
import {
  Toast,
  ConfirmationModal,
  SimpleToolbar,
  Loader,
  Drawer,
  StyledTableCell,
  StyledTableRow,
  BaseTable,
} from "../components";
import { useDrawer } from "../hooks";
import { EnableDisableIconButton } from "../components/icon-buttons";
import handleDownloadExcel from "../helpers/download-excel";
export default function ProductsListApproval(props) {
  const classes = useStyles();
  const [doctors, setDoctors] = useState([]);
  const { authState, signOut } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [doctorId, setDoctorId] = useState(null);
  const [status, setStatus] = useState(null);
  const [reload, setReload] = useState(false);
  const { isOpen, setIsOpen } = useDrawer();
  const tableHeader = useRef([
    "RUT",
    "Nombre",
    "Apellido",
    "Sexo",
    "Fecha de nacimiento",
    "Teléfono",
    "Teléfono de actividad",
    "Correo",
    "Especialidad 1",
    "Especialidad 2",
    "Especialidad 3",
  ]);
  const tableBody = useRef([]);

  useEffect(() => {
    const tableData = doctors.map((doctor) => {
      return {
        RUT: doctor.rut,
        Nombre: doctor.name || "",
        Apellido: doctor.lastName || "",
        Sexo: doctor.gender,
        "Fecha de nacimiento": doctor.birthdate,
        Teléfono: doctor.phone,
        "Teléfono de actividad": doctor.activityPhone,
        Correo: doctor.email,
        "Especialidad 1": doctor.specialties[0]
          ? doctor.specialties[0]?.name
          : "N/A",
        "Especialidad 2": doctor.specialties[1]
          ? doctor.specialties[1]?.name
          : "N/A",
        "Especialidad 3": doctor.specialties[2]
          ? doctor.specialties[2]?.name
          : "N/A",
      };
    });
    tableBody.current = tableData;
  }, [doctors]);

  useEffect(() => {
    // async function getDoctorsPendingAproval() {
    //   setReload(false);
    //   try {
    //     setLoading(true);
    //     const { status, response } = await doctorServices.getDoctorsByStatus({
    //       page,
    //       limit,
    //       token: authState.token,
    //       status: false,
    //     });
    //     setLoading(false);
    //     console.log({ response });
    //     if (status === 200) {
    //       setDoctors(response.doctors);
    //       setLimit(response.limit);
    //       setCount(response.total);
    //       setPage(response.page);
    //     } else if (status === 401) {
    //       signOut();
    //     }
    //   } catch (e) {
    //     setLoading(false);
    //     console.log(e);
    //   }
    // }
    getDoctorsPendingAproval();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, authState, reload]);

  const getDoctorsPendingAproval = async (text = "") => {
    try {
      setLoading(true);
      const { status, response } =
        await doctorServices.getDoctorsByStatusFilter({
          text,
          page,
          limit,
          token: authState.token,
          status: false,
        });
      setLoading(false);
      if (status === 200) {
        setDoctors(response.doctors);
        setLimit(response.limit);
        setCount(response.total);
        setPage(response.page);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const updateStatus = async () => {
    try {
      setLoading(true);
      const { status: statusResp, response } =
        await userServices.updateUserStatus({
          status,
          token: authState.token,
          _id: doctorId,
        });
      setLoading(false);
      if (statusResp === 200) {
        setReload(true);
        setToastMessage("Medico actualizado");
        setToast(true);
      } else if (status === 401) {
        signOut();
      }
      if (response.error) {
        setToastMessage(response.error.message, true);
        setToast(true);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const confirmationModal = (_id, status) => {
    setOpenAlert(true);
    setDoctorId(_id);
    setStatus(status);
  };
  const optionsToolbar = [
    {
      label: "Exportar excel",
      action: (e) => {
        handleDownloadExcel({
          filename: "Doctores",
          tableBody: tableBody.current,
          tableHeader: tableHeader.current,
        });
      },
    },
  ];
  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.container} style={{ flex: 1 }}>
        {loading && <Loader loading={true} />}
        <Grid item sm={12}>
          <div className={classes.root}>
            <Container maxWidth={false}>
              <SimpleToolbar
                isOpen={isOpen}
                setIsOpen={(value) => setIsOpen(value)}
                onFilter={(text) => getDoctorsPendingAproval(text)}
                options={optionsToolbar}
                // table={"tableDoctors"}
                // filename={"Doctores"}
                // tableHeader={tableHeader}
                // tableBody={tableBody}
              />
              <Toast
                message={toastMessage}
                open={toast}
                close={() => {
                  setToast(false);
                }}
              />
              <ConfirmationModal
                open={openAlert}
                setOpenAlert={setOpenAlert}
                setConfirmAction={() => updateStatus()}
              />
              <BaseTable tableId="tableDoctors">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>Rut</StyledTableCell>
                    <StyledTableCell>Nombre</StyledTableCell>
                    <StyledTableCell>Apellido</StyledTableCell>
                    <StyledTableCell>Sexo</StyledTableCell>
                    <StyledTableCell>Fecha de nacimiento</StyledTableCell>
                    <StyledTableCell>Teléfono</StyledTableCell>
                    <StyledTableCell>Correo</StyledTableCell>
                    <StyledTableCell>Especialidad 1</StyledTableCell>
                    <StyledTableCell>Especialidad 2</StyledTableCell>
                    <StyledTableCell>Especialidad 3</StyledTableCell>
                    <StyledTableCell>Opciones</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {doctors.map((doctor, index) => (
                    <StyledTableRow hover key={doctor._id}>
                      <StyledTableCell>
                        {doctor.rut.charAt(doctor.rut.length - 2) === "-"
                          ? doctor.rut
                          : `${doctor.rut.slice(
                              0,
                              doctor.rut.length - 1
                            )}-${doctor.rut.slice(doctor.rut.length - 1)}`}
                      </StyledTableCell>
                      <StyledTableCell>{doctor.name}</StyledTableCell>
                      <StyledTableCell>{doctor.lastName}</StyledTableCell>
                      <StyledTableCell>{doctor.gender}</StyledTableCell>
                      <StyledTableCell>
                        {doctor.birthdate !== "Invalid date"
                          ? doctor.birthdate
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell>
                        {doctor.phone ? doctor.phone : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell>
                        {doctor.email ? doctor.email : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell>
                        {doctor.specialties[0].name}
                      </StyledTableCell>
                      <StyledTableCell>
                        {doctor.specialties[1]
                          ? doctor.specialties[1].name
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell>
                        {doctor.specialties[2]
                          ? doctor.specialties[2].name
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell>
                        <EnableDisableIconButton
                          status={false}
                          tooltipTitleEnable="Aprobar"
                          onClick={() => confirmationModal(doctor.userId, true)}
                        />
                        <EnableDisableIconButton
                          status={true}
                          tooltipTitleDisable="Rechazar"
                          onClick={() =>
                            confirmationModal(doctor.userId, false)
                          }
                        />
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </BaseTable>
              <TablePagination
                labelRowsPerPage="Registros por página"
                component="div"
                count={count}
                onChangeRowsPerPage={(e) => {
                  setLimit(e.target.value);
                }}
                onChangePage={(e, page) => {
                  setPage(page + 1);
                }}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                classes={{ root: classes.pagination }}
              />
            </Container>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  iconButton: {
    "& svg": {
      fill: theme.palette.primary.main,
    },
  },
  check: {
    "&:hover": {
      "& svg": {
        fill: "#22D3C5",
      },
    },
  },
  reject: {
    "&:hover": {
      "& svg": {
        fill: "#FF619A",
      },
    },
  },
  root: {
    width: "100%",
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  pagination: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      bottom: 0,
    },
  },
}));
